/**
 * Корневая оболочка приложения.
 * UI симуляции (панели, canvas, оверлеи) принадлежит {@link AirportHost}.
 */

import { AirportHost } from "@/ui/components/AirportHost";

export default function App() {
  return <AirportHost />;
}
